exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "div.exam {\n  border: 1px solid #efefef;\n  -moz-border-radius: 25px;\n  -webkit-border-radius: 25px;\n  padding: 13px;\n  border-radius: 12px;\n  background: #ffffff;\n  margin-top: 2em; }\n", ""]);
